import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { goToRecruitLook } from '@/lib/recruitlookHandoff';

/**
 * Landing page for signed-in accounts that hold no RLevents admin or staff
 * access. RLevents has no athlete, parent or coach audience — those users
 * belong on RecruitLook.
 */
const AccountNotSetUp: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 py-12">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <CardTitle className="text-2xl">Your account isn't set up for the admin area</CardTitle>
          <CardDescription>
            RecruitLook Events sign-in is for event organisers and staff. Your account doesn't
            have an organisation or staff role yet.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button className="w-full" onClick={() => goToRecruitLook()}>
            Go to the RecruitLook coach dashboard
          </Button>
          <Button asChild variant="outline" className="w-full">
            <Link to="/events">Browse events</Link>
          </Button>
          <p className="text-sm text-muted-foreground pt-2">
            If you should have organiser or staff access, ask the event organiser to invite you.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccountNotSetUp;
